import{SavingAmounts as t}from"./types.js";const m=(m,o)=>(m>=t.minMonthlyAmount||o>=t.minStartAmount)&&o<=t.maxStartAmount&&m<=t.maxMonthlyAmount;export{m as checkInputsIsValid};
//# sourceMappingURL=utils.js.map
